import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    background: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  // [`& .${linearProgressClasses.bar}`]: {
  //   borderRadius: 5,
  //   // backgroundColor: '#1a90ff',
  //   // ...theme.applyStyles('dark', {
  //   //   backgroundColor: '#308fe8',
  //   // }),

  // },
}));

export default BorderLinearProgress;
